import { hydrateRoot } from '@direct-frontend/modules-render/client';
import { createBrowserHistory } from '@direct-frontend/modules-router/client';
import { setI18nLang } from '@adv-frontend/l10n';
import { initErrorBooster, initRum } from '@adv-frontend/yastore-modules/lib';
import { getBoosterConfig } from '@/shared/lib/getBoosterConfig';
import { getRumConfig } from '@/shared/lib/getRumConfig';
import { setRequestContext } from '@/shared/lib/requestContext';
import { Router } from '@/shared/lib/router';
import { Application } from './components/Application';

setI18nLang('ru');

const history = createBrowserHistory();
const rootElement = document.querySelector('#app') || document.documentElement;
const contextElement = document.querySelector('#requestContext');
const requestContext = contextElement?.innerHTML ? JSON.parse(contextElement.innerHTML) : {};
const isDevelopment = requestContext.env === 'development';

setRequestContext(requestContext);

if (!isDevelopment) {
    initRum(
        getRumConfig({
            platform: requestContext.platform,
            env: requestContext.env,
            requestId: requestContext.requestId,
        })
    );
    initErrorBooster(
        getBoosterConfig({
            platform: requestContext.platform,
            env: requestContext.env,
        })
    );
}

contextElement?.remove();

hydrateRoot(
    rootElement,
    <Router history={history}>
        <Application />
    </Router>
);
